import { EditAllocations, usePortfolioSearchModal } from "web/components"
import { usePortfolioAllocations } from "web/hooks/data"
import { useDialogModal, Dialogs, DialogCommands } from "web/hooks/modals"
import { useCurrentTLO } from "web/hooks/context"
import routes from "web/routes/constants"

export default function PortfolioAllocations() {
  const { data: portfolio, userCannot } = useCurrentTLO()

  const portfolioAllocations = usePortfolioAllocations({ portfolio })

  const confirmDeleteModal = useDialogModal(Dialogs.ConfirmDelete("allocation"))
  const dialogModal = useDialogModal()
  const searchModal = usePortfolioSearchModal()

  const hasAllocations =
    Array.isArray(portfolioAllocations) && portfolioAllocations.length !== 0

  const readOnly = userCannot("update")

  function showError(title, prompt) {
    dialogModal({ title, prompt, commands: [DialogCommands.OK] })
  }

  async function handleAddAllocation() {
    const response = await searchModal({
      title: "Add Allocation",
      prompt: "Portfolio to Add",
    })

    if (response) {
      if (
        portfolioAllocations
          .map((el) => el.parent_portfolio.id)
          .includes(response.value)
      ) {
        showError(
          "Allocation Exists",
          "This portfolio is already allocated to portfolio you selected."
        )
      } else if (response.value === portfolio.id) {
        showError(
          "Cannot Allocate To Self",
          "You cannot allocate the portfolio to itself."
        )
      } else {
        await portfolioAllocations.add({
          parent_portfolio_id: response.value,
          fraction: hasAllocations ? 0 : 1,
        })
        portfolio.refresh()
      }
    }
  }

  async function handleRemoveAllocation(index) {
    const dialogResult = await confirmDeleteModal()

    if (dialogResult && dialogResult.response) {
      await portfolioAllocations[index].destroy()
      portfolio.refresh()
    }
  }

  function handleUpdateAllocation(index, values) {
    portfolioAllocations[index].update(values)
  }

  const allocations = portfolioAllocations.map((dp) => ({
    key: dp.parent_portfolio.id,
    label: dp.parent_portfolio.name,
    start_date: dp.start_date,
    end_date: dp.end_date,
    fraction: dp.fraction,
    url: routes.portfolio("all", null, dp.parent_portfolio.id),
  }))

  return (
    <div className="mt-6">
      <EditAllocations
        subjectType="portfolio"
        allocations={allocations}
        onAddAllocation={handleAddAllocation}
        onRemoveAllocation={handleRemoveAllocation}
        onUpdateAllocation={handleUpdateAllocation}
        readOnly={readOnly}
        supportPeriod
      />
    </div>
  )
}
